import { render } from "./WelcomeTourModal.vue?vue&type=template&id=53cda408&scoped=true"
import script from "./WelcomeTourModal.vue?vue&type=script&lang=js"
export * from "./WelcomeTourModal.vue?vue&type=script&lang=js"

import "./WelcomeTourModal.vue?vue&type=style&index=0&id=53cda408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cda408"]])

export default __exports__